module.exports = __webpack_public_path__ + "img/course01.2217bef1.png";